import { atom } from "recoil";

export const authAtom = atom({
  key: "user",
  default: null,
});
